/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Base_Observations_PresentInputs */

const es_co2_error_base_observations_present = /** @type {(inputs: Error_Base_Observations_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El formulario tiene observaciones pendientes por resolver.`)
};

/**

* @param {Error_Base_Observations_PresentInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_base_observations_present = /** @type {((inputs?: Error_Base_Observations_PresentInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Base_Observations_PresentInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_base_observations_present(inputs)
});